(() => {
  const ROOT_ATTR = 'data-fpt';
  const MOTION_ATTR = 'data-fpt-motion';
  const STATIC_ATTR = 'data-fpt-static';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._fptRetry) {
      window.clearTimeout(root._fptRetry);
      root._fptRetry = null;
    }
    if (root._fptCtx) {
      root._fptCtx.revert();
      root._fptCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
  };

  const activePanel = (root) => {
    const checked = root.querySelector('.tabs__item-input:checked');
    if (checked && checked.id) {
      const suffix = checked.id.replace(/^tab-item-input-/, '');
      const panel = root.querySelector(`.tabs__tab-content--${suffix}`);
      if (panel) return panel;
    }
    return root.querySelector('.tabs__tab-content');
  };

  const visibleCards = (cards) =>
    cards.filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.width > 8 && rect.right > 0 && rect.left < window.innerWidth;
    });

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._fptRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    const swiperEl = root.querySelector('.collection-swiper-container');
    if (swiperEl && !swiperEl.swiper) {
      if ((attempt || 0) < RETRY_MAX) {
        root._fptRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    const heading = root.querySelector('[data-fpt-heading]');
    const panel = activePanel(root);
    const cards = panel
      ? Array.prototype.filter.call(panel.querySelectorAll('[data-fpt-card]'), (card) => {
          return !card.classList.contains('swiper-slide-duplicate');
        })
      : [];
    const incoming = visibleCards(cards);
    const playCards = incoming.length ? incoming : cards.slice(0, 5);
    if (!heading && !playCards.length) return;

    root._fptCtx = gsap.context(() => {
      if (heading) gsap.set(heading, { autoAlpha: 0, y: 12 });
      if (playCards.length) gsap.set(playCards, { autoAlpha: 0, y: 12 });

      const parts = [];
      if (heading) parts.push(heading);
      playCards.forEach((card) => parts.push(card));

      gsap.to(parts, {
        autoAlpha: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.04,
        ease: 'power1.out',
        clearProps: 'transform',
        scrollTrigger: {
          trigger: root,
          start: 'top 90%',
          once: true
        }
      });
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
